import { ProcessingNode } from '../ProcessingNode';
/**
 * @category Flow shape
 */
export class FrameFilterNode extends ProcessingNode {
  constructor(filterFn, options) {
    super(options);
    this.options.frameFilter = () => true;
    this.filterFn = filterFn;
  }
  process(frame) {
    return new Promise(resolve => {
      if (this.filterFn(frame)) {
        resolve(frame);
      } else {
        resolve(undefined);
      }
    });
  }
}